import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import getEnv from "env";
import { TCurrentUser } from "models/users.models";
import { BinaryChoice, DatadogCustomActions } from "utils/constants/common";

const useDatadogSetup = (user: TCurrentUser | undefined) => {
  const { datadogRUMEnabled, datadogUserEmailVisible } = getEnv();

  useEffect(() => {
    const isRUMEnabled =
      datadogRUMEnabled === BinaryChoice.toBooleanString(BinaryChoice.Yes);

    const isEmailVisible =
      datadogUserEmailVisible ===
      BinaryChoice.toBooleanString(BinaryChoice.Yes);

    if (isRUMEnabled && isEmailVisible && user?.email) {
      const {
        email,
        organization: { tenantId },
        id,
      } = user;

      datadogRum.setUser({ email, tenantId, id });
      datadogRum.addAction(DatadogCustomActions.EmailCaptured, {
        email,
      });
    }
  }, [datadogRUMEnabled, datadogUserEmailVisible, user]);
};

export default useDatadogSetup;
